<div class="page" style="height: 100%; padding: 3vmin; background: var(--bg-primary)">
  <kgrid
    [apiName]="apiName"
    [noAutoFitColumns]="true"
    [areaName]="areaName"
    [label]="label"
    [name]="apiName"
    reportName="ZonePriceAnnouncement"
    pathPreFix="SALE"
    [isMulti]="true"
    [inputEditorform]="inputEditorform"
    [unSortableFilterable]="unSortableFilterable"
    [isEdit]="isEdit"
    [isDelete]="isDelete"
    [filters]="filters">
  </kgrid>
</div>